module.exports = __webpack_public_path__ + "img/10-about.82d7f38c.jpg";